import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=d37dd6f8&"
import script from "./ShoppingCart.vue?vue&type=script&lang=js&"
export * from "./ShoppingCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports